import "./styles/quasar.scss";
import "quasar/dist/quasar.sass";
import "@quasar/extras/material-icons/material-icons.css";
import "@quasar/extras/line-awesome/line-awesome.css";
import Notify from 'quasar/src/plugins/Notify.js';;
import Dialog from 'quasar/src/plugins/Dialog.js';

// To be used on app.use(Quasar, { ... })
export default {
  config: {},
  plugins: [Notify, Dialog],
  extras: ["line-awesome"],
};
